import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-mandant-options-speichern';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollMandantOptionsSpeichernEffects {

    FunkprotokollMandantOptionsSpeichern$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_MANDANT_OPTIONS_SPEICHERN),
        mergeMap((x: ac.PostFunkprotokollMandantOptionsSpeichernAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollMandantOptionsSpeichern(x.funkprotokollMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollMandantOptionsSpeichernErfolgreichAction(x.funkprotokollMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollMandantOptionsSpeichernFehlerAction(error, x.funkprotokollMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollCommandService);
        }
        return this.service;
    }
}
